// extracted by mini-css-extract-plugin
export default {"slider":"Slider_slider__dLnc5","main":"Slider_main__9XIs1","left":"Slider_left__-FshI","right":"Slider_right__CBV8T"};